import * as OriginalYup from 'yup';
const Yup = Object.assign({}, OriginalYup);

const yupOriginalNumber = Yup.number;

function NumberSchemaType() {
    if (!(this instanceof NumberSchemaType)) {
        return new NumberSchemaType();
    }

    yupOriginalNumber.call(this);
    this._nullable = true;
    this.withMutation(() => {
        this.transform(function(value, originalvalue) {
            return isNaN(value) ? null : value;
        });
    });
}

NumberSchemaType.prototype = Object.create(Yup.number.prototype);
NumberSchemaType.prototype.constructor = NumberSchemaType;
NumberSchemaType.prototype._typeCheck = function(value) {
    return isNaN(value) || yupOriginalNumber.prototype._typeCheck.call(this, value);
};

Yup.number = NumberSchemaType;

Yup.setLocale({
    number: {
        max: ({max}) => ({key: 'max', params: {max}}),
        min: ({min}) => ({key: 'min', params: {min}}),
        moreThan: ({more}) => ({key: 'more', params: {more}}),
    },
    string: {
        required: () => ({key: 'required'}),
    },
    mixed: {
        required: () => ({key: 'required'}),
        max: ({max}) => ({key: 'max', params: {max}}),
        min: ({min}) => ({key: 'min', params: {min}}),
    },
});

export default Yup;
